import WisetackLearnMore from './WisetackLearnMore'

export * from './WisetackLearnMore'
export default WisetackLearnMore
